import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../environments/environment';
import { GuidService, FormValidationService, FormValidator, ValidationError } from 'core-lib';
import { LocalParserFormatter, LocalDateStruct } from 'core-lib';
import { ErrorHandlingService, AlertService } from 'core-lib';

import {
  PermitService, PermitDetailsModel, PermitDetailsVehicleItemModel,
  WaterUsageCreateResponseData, WaterUsageItemModel, TransactionDetailsResponseData, PermitDetailsTransactionItemModel
} from '../services/permit.service';

import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'cli-water-usage',
  templateUrl: './water-usage.component.html',
  styleUrls: ['./water-usage.component.scss']
})

export class WaterUsageComponent implements OnInit {


  public vm: WaterUsageModalViewModel;
  private validator: FormValidator;
  private permit: PermitDetailsModel;
  private transaction: PermitDetailsTransactionItemModel;

  constructor(private formValidationSvc: FormValidationService,
    private formatter: LocalParserFormatter,
    private router: Router,
    private permitSvc: PermitService,
    private alertSvc: AlertService,
    private guisSvc: GuidService,
    private errorHandilingSvc: ErrorHandlingService,
    private route: ActivatedRoute) {

    this.vm = new WaterUsageModalViewModel();
    this.vm.maxDate = this.formatter.fromMoment(moment().startOf('day'));
    this.validator = this.formValidationSvc.getFormValidator(this.vm);

    this.vm.transactionId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {

    if (this.permitSvc.model == null) {
      this.vm.isLoading = true;
    }

    var promises$ = [];

    var permit$ = this.permitSvc.getDetails()
      .toPromise().then((data: PermitDetailsModel) => {

        this.permit = data;

        this.vm.businessName = data.permitDetails.clientName;
        this.vm.contactName = data.permitDetails.firstName + ' ' + data.permitDetails.lastName
        this.vm.permitNo = data.permitDetails.permitNo;

        this.loadData();

      },
        (e) => { this.errorHandilingSvc.processHttpError(e); });


    promises$.push(permit$);

    if (this.vm.transactionId) {
      var transaction$ = this.permitSvc.getTransactions({ transactionId: this.vm.transactionId })
        .toPromise().then((data: TransactionDetailsResponseData) => {

          if (data.items.length > 0) {
            this.transaction = data.items[0];
          }

        },
          (e) => { });

      promises$.push(transaction$);
    }


    Promise.all(promises$).then(() => {

      this.loadData();

    }).finally(() => {
      this.vm.isLoading = false;
    })

  }

  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this.vm, fieldName);
  }

  public proceedYes() {

    this.vm.isLoading = true;
    this.save().then(() => {

      let filter = { skip: 0, take: 20 };

      return this.permitSvc.getTransactions(filter).toPromise()
        .then((data: TransactionDetailsResponseData) => {

          this.permitSvc.model.transactions = data.items;
          this.permitSvc.model.transactionCount = data.totalCount;

          this.alertSvc.success(environment.TOASTR_HEADER, 'The water usage record successfully created', 2000, true);

          this.router.navigate(['/app/transactions']);

        }, (e) => { });
    }, (e) => { }).finally(() => { this.vm.isLoading = false; });

  }

  public proceedCancel() {
    this.router.navigate(['/app/transactions']);
  }

  public loadData() {

    this.vm.waterUsageId = this.guisSvc.getGuid();
    this.vm.vehicles = _(this.permit.vehicles)
      .filter((v: PermitDetailsVehicleItemModel) => v.status == 'Active')
      .map((v: PermitDetailsVehicleItemModel) => {

        let uv = new WaterUsageVehicleModel();
        uv.vehicleId = v.vehicleId;
        uv.description = `${v.rego} (${v.capacity} L)  ${v.vehicleType || ''}`;
        uv.capacity = v.capacity;
        return uv;

      })
      .value();

    let time = moment('2000-01-01T23:30');

    for (let i = 0; i < 48; i++) {
      time = time.add(30, 'minutes');

      let t = new WaterUsageTimeModel();
      t.timeId = time.format('HH:mm');
      t.description = time.format('hh:mm A');

      this.vm.times.push(t);
    }

    this.vm.usageRate = this.permit.currentRates.usageRate;

    if (this.transaction) {

      let v = _.find(this.permit.vehicles, (n: PermitDetailsVehicleItemModel) => this.transaction.regoNo === n.rego);

      this.vm.waterUsageId = this.transaction.transactionId;
      this.vm.vehicleId = v.vehicleId;

      this.vm.fillDate = this.formatter.fromMoment(moment(this.transaction.fillDate).startOf('day'));
      this.vm.fillTime = moment(this.transaction.fillDate).format('HH:mm');

      this.vm.suburb = this.transaction.location;
      this.vm.comment = this.transaction.comment;
    }
    else {
      this.vm.fillDate = this.formatter.fromMoment(moment().startOf('day'));
      this.vm.fillTime = '09:00';

      if (this.vm.vehicles && this.vm.vehicles.length > 0) {
        let v = this.vm.vehicles[0];
        this.vm.vehicleId = v.vehicleId;
      }

    }

    this.calculateCost();

  }

  public calculateCost() {

    let v = _.find(this.vm.vehicles, (n: WaterUsageVehicleModel) => {
      return this.vm.vehicleId === n.vehicleId;
    });

    if (v == null) {
      this.vm.usage = 0;
      this.vm.usageCost = 0;

      return;
    }

    this.vm.usage = v.capacity;
    this.vm.usageCost = this.vm.usage / 1000 * this.vm.usageRate;

  }

  public validate(vm: WaterUsageModalViewModel): Promise<void> {
    vm.errors = [];

    this.validator.validateRequired('vehicleId', 'Vehicle');

    this.validator.validateRequired('suburb', 'Suburb');
    this.validator.validateMaxLength('suburb', 'Suburb', 100);

    this.validator.validateRequired('fillDate', 'Date');
    this.validator.validateRequired('fillTime', 'Time');

    this.validator.validateCustom('fillDate',
      'The date cannot be in the future',
      () => { return this.formatter.toDate(this.vm.fillDate) > moment().startOf('day').toDate(); });

    if (vm.errors.length > 0) { return Promise.reject('Invalid input'); }

    return Promise.resolve();

  }

  public save(): Promise<void> {

    return this.validate(this.vm).then(() => {

      let w = new WaterUsageItemModel();
      w.waterUsageId = this.vm.waterUsageId;
      w.vehicleId = this.vm.vehicleId;
      w.permitId = this.permit.permitDetails.permitId;
      w.location = this.vm.suburb;

      let dt: LocalDateStruct = _.clone(this.vm.fillDate);
      let hhmm = this.vm.fillTime.split(':');
      dt.hour = parseInt(hhmm[0], 10);
      dt.minute = parseInt(hhmm[1], 10);

      w.usageDate = this.formatter.toIsoString(dt);
      w.fillLoads = 1;
      w.fillType = 'Loads';
      w.comment = this.vm.comment;

      w.isBulk = false;
      w.isCreatedByAdmin = false;
      w.isDoNotBill = false;

      let p$: Promise<WaterUsageCreateResponseData>;

      if (!this.transaction) {
        p$ = this.permitSvc.createWaterUsage(w).toPromise();
      }
      else {
        p$ = this.permitSvc.updateWaterUsage(w).toPromise();
      }

      return p$.then((data: WaterUsageCreateResponseData) => {
      },
        (e) => {
          let errorMessage = this.errorHandilingSvc.processHttpError(e);
          return Promise.reject(errorMessage);
        });

    }, (e) => {
      return Promise.reject(e);
    });
  }
}

export class WaterUsageModalViewModel {

  constructor() {
    this.vehicles = [];
    this.times = [];
  }
  public transactionId: string;

  public isOpening: boolean;
  public isLoading: boolean;
  public maxDate: any;
  public businessName: string;
  public contactName: string;
  public permitNo: string;

  public waterUsageId: string;
  public vehicleId: string;
  public suburb: string;
  public fillDate: any;
  public fillTime: string;
  public comment: string;

  public usageRate: number;
  public usageCost: number;
  public usage: number;

  public vehicles: WaterUsageVehicleModel[];
  public times: WaterUsageTimeModel[];

  public errors: ValidationError[];
  public header: string;
}

export class WaterUsageVehicleModel {

  public vehicleId: string;
  public description: string;
  public capacity: number;
}

export class WaterUsageTimeModel {
  public timeId: string;
  public description: string;
}